import PageBackBar from "@/components/PageBackBar";
import BookingBlock from "@/components/BookingBlock";
import { useSite } from "@/Layout";

export default function BookPage() {
  const { config } = useSite();
  return (
    <div data-testid="book-page">
      <PageBackBar testId="book-back-bar" />
      <BookingBlock config={config} />
    </div>
  );
}
